import { Link } from "react-router-dom";
import { usePageContent } from "@/context/PageContentContext";
import Seo from "@/components/site/Seo";

export default function Leadership() {
  const c = usePageContent();
  return (
    <>
      <Seo />
      <section className="gp-on-white" data-testid="leadership-hero"
        style={{ paddingTop: "clamp(48px, 6vw, 72px)", paddingBottom: 24 }}>
        <div className="gp-wrap gp-narrow" style={{ textAlign: "center" }}>
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)", justifyContent: "center" }}>
            <span className="gp-eyebrow-num">01</span><span className="gp-eyebrow-sep" /> Leadership
          </div>
        </div>
      </section>

      <section className="gp-on-white" data-testid="leadership-message-section"
        style={{ paddingTop: 24, paddingBottom: "clamp(80px, 10vw, 120px)" }}>
        <div className="gp-wrap gp-narrow" style={{ textAlign: "center" }}>
          <h1 className="gp-h1" style={{ fontSize: "clamp(2rem, 4vw, 3rem)", margin: "0 0 12px" }}>Ken Salvadore</h1>
          <div className="gp-lead__role" data-testid="leadership-role">President &amp; CEO</div>
          <hr className="gp-rule-gold" style={{ width: 40, margin: "24px auto 32px" }} />
          <p className="gp-lead__msg" data-testid="leadership-message"
            style={{ fontSize: 19, lineHeight: 1.6, maxWidth: 720, margin: "0 auto", color: "var(--gp-ink)" }}>
            {c["leadership.message"]}
          </p>
          <div style={{ marginTop: 32 }}>
            <Link to="/contact" className="gp-link" data-testid="leadership-cta-contact">
              Contact our team <span className="gp-arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
